module.exports = __webpack_public_path__ + "img/flag-eng.81bce31d.png";